import React, { useState } from "react";
import Select, { components } from "react-select";
import Checkbox from "components/Checkbox";
import { useFormattedMessage } from "hooks";

const messages = {
    search: "search_text",
};

const Option = (props) => {
    const title = typeof props?.label === "object" ? props?.data?.title : props?.label;
    return (
        <div>
            <components.Option {...props}>
                <div style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0 }} title={title} />
                <Checkbox
                    inputId={title}
                    size="small"
                    value={props?.isSelected}
                    label={props?.label}
                    labelClassName={`text-left text-14 ${props?.data?.isMultiLine ? "" : "single-line-label"}`}
                />
            </components.Option>
        </div>
    );
};

const MultiValue = (props) => {
    const title = typeof props.data.label === "object" ? props.data.title || props.data.value : props.data.label;
    return (
        <components.MultiValue {...props}>
            <span title={title}>{props.data.customSelectedLabel || props.data.label}</span>
        </components.MultiValue>
    );
};

const orderOptions = (values) => {
    return values.filter((v) => v.isFixed).concat(values.filter((v) => !v.isFixed));
};

const styles = {
    multiValueRemove: (base, state) => {
        return state.data.isFixed ? { ...base, display: "none" } : base;
    },
};

const Control = ({ children, ...props }) => {
    return (
        <components.Control {...props}>
            <span style={{ pointerEvents: "none", padding: "0 0px 0 16px" }}>
                <i style={{ color: "#74757d" }} className="fa fa-search" aria-hidden="true" />
            </span>
            {children}
        </components.Control>
    );
};

const DropDownSelectInput = ({
    selectClassName = "select",
    classNamePrefix = "select",
    className = "",
    errorMessage = "",
    success = false,
    currency = "",
    errorIcon = true,
    error,
    menuPlacement = "bottom",
    maxMenuHeight,
    label,
    errorClassName = "error-element",
    id = "select-input-instanceId",
    isMultiSelectWithCheckbox = false,
    hideSelectedOptions = true,
    innerRef,
    options,
    onChange = () => {},
    isOptionWithFixedValue = false,
    showAllSelectedItems = false,
    searchPlaceholder = "",
    isSearchable = true,
    isMulti,
    value,
    ...rest
}) => {
    const { formatMessage } = useFormattedMessage();
    const [isOpenSelect, setOpenSelect] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const onChangeSelect = (value, actionMeta) => {
        switch (actionMeta.action) {
            case "remove-value":
            case "pop-value":
                if (actionMeta.removedValue.isFixed) {
                    return;
                }
                break;
            case "clear":
                value = options.filter((v) => v.isFixed);
                break;
        }

        value = orderOptions(value);
        onChange(value);
        !isMulti ? setOpenSelect(false) : null;
    };

    const filterOption = (option, input) => {
        if (input) {
            return option?.data
                ? option?.data?.searchLabel?.toLowerCase().includes(input?.toLowerCase()) ||
                      option?.data?.value?.toLowerCase()?.includes(input?.toLowerCase())
                : option?.value?.toLowerCase()?.includes(input?.toLowerCase());
        }
        return true;
    };

    const onOpenSelect = (element) => {
        setInputValue("");
        setOpenSelect(true);
        const labelPosition = element.target?.parentElement?.getBoundingClientRect()?.left;
        const labelWidth = element.target?.offsetWidth || 0;
        if (window.innerWidth <= 767 && labelPosition + labelWidth < 240) {
            if (element.target.nextSibling) {
                element.target.nextSibling.style.left = "0px";
            }
        } else {
            if (element.target.nextSibling) {
                element.target.nextSibling.style.right = "0px";
                element.target.nextSibling.style.left = "inherit !important";
            }
        }
    };

    const handleInputChange = (value, reason) => {
        if (reason.action == "input-change") {
            setInputValue(value);
        }
    };

    return (
        <div
            className={`form-element dropdown-select ${isOpenSelect ? "open" : ""} ${
                showAllSelectedItems ? "multiline-select" : ""
            } ${className} ${error && errorMessage && `${errorClassName}`} ${
                isMultiSelectWithCheckbox ? "custom-select-checkbox" : ""
            } ${selectClassName == "small-menu-list" ? "custom-small-select" : ""}`}
        >
            <div className="dropdown-label d-flex align-center justify-center" onClick={(e) => onOpenSelect(e)}>
                {label}
            </div>
            <div className={`select-container ${isOpenSelect ? "" : "d-none"}`}>
                <Select
                    {...rest}
                    value={value}
                    inputValue={inputValue}
                    onInputChange={handleInputChange}
                    autoFocus
                    menuIsOpen
                    ref={innerRef}
                    filterOption={filterOption}
                    options={options || []}
                    menuPlacement={menuPlacement}
                    maxMenuHeight={maxMenuHeight}
                    isSearchable={isSearchable}
                    className={`${isSearchable ? "" : "hide-search"} ${
                        selectClassName === "select" ? "select" : `select ${selectClassName}`
                    }`}
                    classNamePrefix={classNamePrefix}
                    instanceId={id}
                    closeMenuOnSelect={isMultiSelectWithCheckbox ? false : true}
                    components={isMultiSelectWithCheckbox ? { Control, Option, MultiValue } : { Control }}
                    hideSelectedOptions={isMultiSelectWithCheckbox ? false : hideSelectedOptions}
                    backspaceRemovesValue={isMultiSelectWithCheckbox ? false : true}
                    onChange={
                        isOptionWithFixedValue
                            ? onChangeSelect
                            : isMultiSelectWithCheckbox && !isMulti
                              ? (innerVal) => {
                                    if (innerVal?.value === value?.value) {
                                        onChange("");
                                    } else {
                                        onChange(innerVal);
                                    }
                                    !isMulti ? setOpenSelect(false) : null;
                                }
                              : (value) => {
                                    onChange(value), !isMulti ? setOpenSelect(false) : null;
                                }
                    }
                    styles={
                        isOptionWithFixedValue
                            ? {
                                  ...styles,
                                  noOptionsMessage: (base) => ({
                                      ...base,
                                      ...{ padding: "28px 16px", fontSize: "14px" },
                                  }),
                              }
                            : { noOptionsMessage: (base) => ({ ...base, ...{ padding: "28px 16px", fontSize: "14px" } }) }
                    }
                    controlShouldRenderValue={false}
                    placeholder={searchPlaceholder || formatMessage(messages.search)}
                    isMulti={isMulti}
                />
                {currency && <span className="currency">{currency}</span>}
                {success && !errorMessage && <i className="fas fa-check" />}
                {error && (
                    <>
                        {errorMessage && errorIcon && <i className={`fas fa-exclamation-triangle ${label && " with-label"}`} />}
                        {errorMessage && <label className="error-label text-left">{errorMessage}</label>}
                    </>
                )}
            </div>
            <div className={`blanket ${isOpenSelect ? "" : "d-none"}`} onClick={() => setOpenSelect(false)} />
        </div>
    );
};

export default DropDownSelectInput;
